package co.uk.paxes.pinpoint.model

import kotlinx.serialization.Serializable

@Serializable
data class Player(
    val id: String,
    val name: String,
    val score: Int = 0,
    val jokersUsed: Int = 0,
    val isAI: Boolean = false,
    val aiDifficulty: String? = null, // "EASY", "MEDIUM", "HARD", "EXPERT"
    val isHost: Boolean = false
) {
    companion object {
        fun human(id: String, name: String) = Player(
            id = id,
            name = name,
            isAI = false
        )
        
        fun ai(id: String, name: String, difficulty: String) = Player(
            id = id,
            name = name, // Don't add emoji here - let display logic handle it
            isAI = true,
            aiDifficulty = difficulty
        )
    }
    
    fun canUseJoker(): Boolean {
        return jokersUsed < 4
    }

    fun withScore(newScore: Int): Player {
        return copy(score = newScore)
    }
    
    /**
     * Use a joker (increment count)
     */
    fun useJoker(): Player = copy(jokersUsed = jokersUsed + 1)
    
    /**
     * Restore a joker (decrement count) - used when undoing a joker move
     */
    fun restoreJoker(): Player = copy(jokersUsed = (jokersUsed - 1).coerceAtLeast(0))
}
